// An extraction is in flight while it waits on the queue ("pending") or a worker
// is running it ("running"). Every poll of extraction_status stops at the first
// status that is neither.
export const isExtractionInFlight = (status: string | null | undefined): boolean =>
  status === "pending" || status === "running";
